import 'css-chunksrc/client/pages/exportsPage/resourceReport/styles.scss';export default {
  "resourceReport": "_resourceReport_gsss0_1",
  "checked": "_checked_gsss0_10",
  "checkbox": "_checkbox_gsss0_14",
  "col": "_col_gsss0_20",
  "name": "_name_gsss0_24",
  "description": "_description_gsss0_31",
  "button": "_button_gsss0_36"
};